//
// LayoutOverlay.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BaseLayoutOverlay";
import "./Overlay";
import "../axis/AxisOptions";
import "../core/styles/FillAttributes";
import "./WallDisplay";
import "./InnerMargin";
import "./AspectRatioType";

var LayoutOverlay = createModule("gtl_LayoutOverlay", [130,13,20148,20355,20098,20222,20056,20234], EventDispatcher, [
    ,
    {
        wallDisplay: 1,
        alignHorizontalAxisTicks: 2,
        topAxisHeightMax: 5,
        yAxisOptions: 1,
        aspectRatioType: 4,
        aspectRatio: 5,
        rightAxisWidthMax: 5,
        wallAttributes: 1,
        x2AxisOptions: 1,
        y2AxisOptions: 1,
        useDefaultZoomController: 2,
        leftAxisWidthMax: 5,
        overlays: [1],
        bottomAxisHeightMax: 5,
        alignVerticalAxisTicks: 2,
        innerMargins: [1],
        xAxisOptions: 1,
    },
    ,
    ,
    {
        needsX2Axis: [2],
        needsXAxis: [2],
        needsY2Axis: [2],
        needsYAxis: [2],
    },
    {
        _create: [4],
    },
    ,
]);
export default LayoutOverlay;
